module.exports = __webpack_public_path__ + "media/images/golden_pin_design_award_icon-w-701da6e587ed4861afa7e94282dcacff.png";